module.exports = __webpack_public_path__ + "img/portfolio-7.70fae66f.jpg";